export default {
  currentBreadcrumb: state => state.breadcrumb.currentBreadcrumb
};
